import React from 'react';

import withAppState from '../mobx/withAppState'
import { getCsrfToken, handleCsrfFailure } from '../helpers/GetCsrfToken';
import plusIcon from '../assets/img/plus.svg';
import minusIcon from '../assets/img/minus.svg';

const elementPlus = <img src={plusIcon} alt="plus" />;
const elementMinus = <img src={minusIcon} alt="minus" />;

const removeItemFromSplit = async (props, item) => {
  const { selectedSplitIndex } = props;

  if (!props.bill || !props.bill[0]) {
    console.error("No bill object found");
    return
  }

  const { providerId } = props.bill[0]
  const response = await fetch(
    `api/Bill/RemoveItemFromSplit/${providerId}/${props.restaurant.id}/${props.tableNumber}`,
    {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCsrfToken()
      },
      body: JSON.stringify({
        item,
        splitIndex: selectedSplitIndex
      })
    }
  );

  if (response.status === 200) {
    let data;
    try {
      data = await response.json();
    } catch (err) {
      props.setErrorModalMessage("Error retrieving bill");
      return;
    }
    const { bills } = data;
    props.setBill(bills);
  } else if (response.status === 400) {
    handleCsrfFailure();
  }
};

const addItemToSplit = async (props, item) => {
  const { selectedSplitIndex } = props;
  const response = await fetch(
    `api/Bill/AddItemToSplit/${props.bill[0].providerId}/${props.restaurant.id}/${props.tableNumber}`,
    {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCsrfToken()
      },
      body: JSON.stringify({
        item,
        splitIndex: selectedSplitIndex
      })
    }
  );
  if (response.status === 200) {
    let data;
    try {
      data = await response.json();
    } catch (err) {
      props.setErrorModalMessage("Error retrieving bill");
      return
    }
    const { bills } = data;
    props.setBill(bills);
  } else if (response.status === 400) {
    handleCsrfFailure();
  }
};

const splitBillItemsSelected = (props) => {
  const { split } = props;

  if (!!split && !!split.items) {
    if (split.items.length === 0) {
      return (
        <div className="bill-items-none">
          <p className="item-name">None</p>
        </div>
      );
    } else {
      const paid = split.paid;
      return split.items.map((item, index) => {
        const removeFromSplitBillButton =
          paid === false ? (
            <button onClick={() => removeItemFromSplit(props, item)}>              
              {elementMinus}
            </button>
          ) : null;

        const additionNames =
          item.additions.length > 0
            ? item.additions.map((addition, adIndex) => {
              if (addition.cost > 0) {
                return (
                  <p key={`${index}-n${adIndex}`} className="item-additions">
                    {` + ${addition.name}`}
                  </p>
                );
              }
              return null;
            })
            : null;

        const additionQuantities =
          item.additions.length > 0
            ? item.additions.map((addition, adIndex) => {
              if (addition.cost > 0) {
                return (
                  <p key={`${index}-q${adIndex}`} className="item-additions">
                    {`${addition.quantity}`}
                  </p>
                );
              }
              return null;
            })
            : null;

        const additionCosts =
          item.additions.length > 0
            ? item.additions.map((addition, adIndex) => {
              if (addition.cost > 0) {
                return (
                  <p key={`${index}-c${adIndex}`} className="item-additions">
                    {`${props.currency.symbol + addition.cost.toFixed(2)}`}
                  </p>
                );
              }
              return null;
            })
            : null;

        return (
          <div className="bill-item-block-container">
            <ul
              className="bill-item-block bill-category-subtotal picked"
              key={index}
            >
              <li className="bill-item-text">
                <div className="item-description">
                  <p className="item-name">
                    {`${item.name} ${
                      !!item.description ? `${item.description}` : ``
                    }`}
                  </p>
                  {additionNames}
                </div>
              </li>
              <li className="bill-item-quantity">
                <p>{item.quantity}</p>
                {additionQuantities}
              </li>
              <li className="bill-item-amount">
                <p>{props.currency.symbol + item.cost.toFixed(2)}</p>
                {additionCosts}
              </li>
              <li className="bill-item-btn">
                {removeFromSplitBillButton}{' '}
              </li>
            </ul>
          </div>
        );
      });
    }
  } else return null;
};

function SplitByItem(props) {
  const { availableItems } = props;
  if (!availableItems) return null;

  return (
    <div>
      {!!props.split && props.selectedSplitIndex != null ? <div ref={props.splitBillInfoRef} className="bill-items-basket">
        <div className="bill-title-block">
          <div className="bill-title-block-inner">
            <div className="title-column">
              <h3 className="title">BASKET</h3>
            </div>
          </div>
        </div>

        {splitBillItemsSelected(props)}
      </div> : null}
      <div className={`bill-items-picklist ${!!props.split && props.selectedSplitIndex != null ? '' : 'summary'}`}>
        <div className="bill-title-block">
          <div className="bill-title-block-inner">
            <div className="title-column">
              <h3 className="title">REMAINING</h3>
            </div>
          </div>
        </div>
        {availableItems.length === 0 ? (
          <div className="bill-items-none">
            <p className="item-name">None</p>
          </div>
        ) : (
          availableItems.map((item, index) => {
            var itemName = item.name;
            var description = item.description;
            var quantity = item.quantity;
            var cost = parseFloat(item.cost);
            var additionNames =
              item.additions.length > 0
                ? item.additions.map((addition, adIndex) => {
                    if (addition.cost > 0) {
                      return (
                        <p
                          key={`${index}-n${adIndex}`}
                          className="item-additions"
                        >
                          {` + ${addition.name}`}
                        </p>
                      );
                    }
                    return null;
                  })
                  : null;
              var additionQuantities =
                item.additions.length > 0
                  ? item.additions.map((addition, adIndex) => {
                    if (addition.cost > 0) {
                      return (
                        <p
                          key={`${index}-q${adIndex}`}
                          className="item-additions"
                        >
                          {`${addition.quantity}`}
                        </p>
                      );
                    }
                    return null;
                  })
                  : null;
              var additionCosts =
                item.additions.length > 0
                  ? item.additions.map((addition, adIndex) => {
                    if (addition.cost > 0) {
                      return (
                        <p
                          key={`${index}-c${adIndex}`}
                          className="item-additions"
                        >
                          {`${props.currency.symbol + addition.cost.toFixed(2)}`}
                        </p>
                      );
                    }
                    return null;
                  })
                  : null;
              const addToSplitBillButton =
                !!props.split && props.split.paid === false ? (
                  <button onClick={() => addItemToSplit(props, item)}>
                    {elementPlus}
                  </button>
                ) : null;

              return (
                <div className="bill-item-block-container">
                  <ul
                    className="bill-item-block bill-category-subtotal remaining"
                    key={index}
                  >
                    <li className="bill-item-text">
                      <div className="item-description">
                        <p className="item-name">
                          {`${itemName} ${!!description ? `${description}` : ``}`}
                        </p>
                        {additionNames}
                      </div>
                    </li>
                    <li className="bill-item-quantity">
                      <p>{quantity}</p>
                      {additionQuantities}
                    </li>
                    <li className="bill-item-amount">
                      <p>{props.currency.symbol + cost.toFixed(2)}</p>
                      {additionCosts}
                    </li>
                    <li className="bill-item-btn">
                      {addToSplitBillButton}{' '}
                    </li>
                  </ul>
                </div>
              );
            })
          )}
      </div>
    </div>
  );
}


export default withAppState(SplitByItem,
  {
    mobXProps: ({
      restaurant,
      tableNumber,
      bill,
    }) => ({
      restaurant,
      tableNumber,
      bill,
    }),
    mobXActions: ({
      setBill,
      setErrorModalMessage
    }) => ({
      setBill,
      setErrorModalMessage
    })
  }
);